var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4966_74994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4966_74994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 14.1667H5.83464C4.68186 14.1667 3.69922 13.7604 2.88672 12.9479C2.07422 12.1354 1.66797 11.1528 1.66797 10C1.66797 8.84723 2.07422 7.86459 2.88672 7.05209C3.69922 6.23959 4.68186 5.83334 5.83464 5.83334H9.16797V7.50001H5.83464C5.14019 7.50001 4.54991 7.74307 4.0638 8.22918C3.57769 8.71529 3.33464 9.30557 3.33464 10C3.33464 10.6945 3.57769 11.2847 4.0638 11.7708C4.54991 12.257 5.14019 12.5 5.83464 12.5H9.16797V14.1667ZM6.66797 10.8333V9.16668H13.3346V10.8333H6.66797ZM10.8346 14.1667V12.5H14.168C14.8624 12.5 15.4527 12.257 15.9388 11.7708C16.4249 11.2847 16.668 10.6945 16.668 10C16.668 9.30557 16.4249 8.71529 15.9388 8.22918C15.4527 7.74307 14.8624 7.50001 14.168 7.50001H10.8346V5.83334H14.168C15.3207 5.83334 16.3034 6.23959 17.1159 7.05209C17.9284 7.86459 18.3346 8.84723 18.3346 10C18.3346 11.1528 17.9284 12.1354 17.1159 12.9479C16.3034 13.7604 15.3207 14.1667 14.168 14.1667H10.8346Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.0d285a8f66add026c61700c9827ae513.svg";
export { ForwardRef as ReactComponent };